module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daythunderstorm@2-c658db738dff6c98bcd47187577cd6a7.png";